module.exports = __webpack_public_path__ + "static/images/logo-excel.1oyrJjv.png";